var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"CurrencyIcon ml-1 mr-2",attrs:{"src":_vm.imageUrl,"alt":_vm.name,"title":_vm.description}})
}
var staticRenderFns = []

export { render, staticRenderFns }